import type { TGroupType, THiddenOffer, TOffer } from 'shared/types/TRankingService';

export const getOffersToShowFromHiddenOffers = ({
  hiddenOffers,
  hiddenOfferIds,
  targetGroup,
}: {
  hiddenOffers: THiddenOffer[];
  hiddenOfferIds: string[];
  targetGroup: TGroupType;
}) => {
  const hiddenOfferIdsSet = new Set(hiddenOfferIds);

  return hiddenOffers.reduce<{
    offersToShow: TOffer[];
    remainingHiddenOffers: THiddenOffer[];
  }>(
    (acc, hiddenOffer) => {
      if (hiddenOfferIdsSet.has(hiddenOffer.id)) {
        const { causes: _, ...offerData } = hiddenOffer;

        acc.offersToShow.push({
          ...offerData,
          group: targetGroup,
        });
      } else {
        acc.remainingHiddenOffers.push(hiddenOffer);
      }

      return acc;
    },
    {
      offersToShow: [],
      remainingHiddenOffers: [],
    },
  );
};
